<script setup>
/******************************************************************************
 * PageComponent: ReadingReqEmail
 *****************************************************************************/
import FormRow from "Components/Form/FormRow.vue";
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
import { ref } from "vue";
const props = defineProps({
    email: { type: String, default: "" },
    customerNo: { type: String, default: "" },
    clientId: { type: Number, required: true },
});
const inputValue = ref(props.email);
const emit = defineEmits(["change"]);
const onChange = () => emit("change", inputValue.value);
</script>

<template>
    <form-row
        :required="false"
        label="E-Mail-Adresse"
        :for-id="`email-knr${props.customerNo}-mnd${props.clientId}`"
        :top="0.5"
    >
        <template #input>
            <input
                :id="`email-knr${props.customerNo}-mnd${props.clientId}`"
                v-model="inputValue"
                :name="`email-knr${props.customerNo}-mnd${props.clientId}`"
                class="form-input form-input--has-addon"
                type="email"
                inputmode="email"
                maxlength="120"
                @keyup="onChange"
            />
            <span class="form-input-addon">
                <svg-icon name="email" :size="1" />
            </span>
        </template>
    </form-row>
</template>
